import { useSyncExternalStore } from 'react';
import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  browserConnectivityStore,
  type ConnectivityStore,
} from '../lib/connectivity';
import { HOME_PATH } from '../lib/navigation';

interface AppHeaderProps {
  connectivityStore?: ConnectivityStore;
}

export function AppHeader({
  connectivityStore = browserConnectivityStore,
}: AppHeaderProps): JSX.Element {
  const online = useSyncExternalStore(
    connectivityStore.subscribe,
    connectivityStore.getSnapshot,
    connectivityStore.getServerSnapshot,
  );
  const connectivityLabel = online ? 'Online' : 'Offline';

  return (
    <header className="cr-app-header">
      <div className="cr-app-header__inner">
        <div className="cr-app-header__control-zone cr-app-header__control-zone--left">
          <button
            type="button"
            className="cr-app-header__menu"
            aria-label="Navigation menu"
            aria-disabled="true"
          >
            <Menu size={22} strokeWidth={2.3} aria-hidden="true" />
          </button>
        </div>

        <div className="cr-app-header__brand">
          <Link
            to={HOME_PATH}
            className="cr-app-header__home"
            aria-label="Conscious Ritual Home"
          >
            <img
              className="cr-app-header__wordmark cr-app-header__wordmark--light"
              src="/branding/conscious-ritual-wordmark.svg"
              alt=""
              aria-hidden="true"
            />
            <img
              className="cr-app-header__wordmark cr-app-header__wordmark--dark"
              src="/branding/conscious-ritual-wordmark-dark.svg"
              alt=""
              aria-hidden="true"
            />
          </Link>
        </div>

        <div className="cr-app-header__control-zone cr-app-header__control-zone--right">
          <span
            className={`cr-app-header__connectivity ${online ? 'is-online' : 'is-offline'}`}
            role="status"
            aria-label={connectivityLabel}
            title={`${connectivityLabel} — browser connectivity`}
          >
            <span aria-hidden="true" />
          </span>
        </div>
      </div>
    </header>
  );
}
